
<div class="wrap">
    <mat-card *ngIf="!directLoginBlock">
        <mat-card-title>
            Authentication Error
        </mat-card-title>
        <mat-card-content>
            <p>Something went wrong when attempting to authenticate with your credentials.</p>

			<div *ngIf="!isFLNAPIerror && !isSSOerror">
				<p>The issue could either be:</p>
				<ul>
					<li>The credentials provided are incorrect</li>
					<li>The account associated with the credentials has been deactivated</li>
					<li>The authentication server may be experiencing some issues</li>
				</ul>
			</div>

			<div *ngIf="isFLNAPIerror && !isSSOerror">
				<p>FLNAPI Error: {{errorMessage}}</p>
				<p>{{serviceReported}}</p>
			</div>

			<div *ngIf="!isFLNAPIerror && isSSOerror && !invalidToken && ssoSource">
				<p>{{ssoSource}} Error: {{errorMessage}}</p>
				<ul>
					<li>No Success Account matched this {{ssoSource}} username.</li>
					<li>Please contact support to setup an account</li>
				</ul>
			</div>

			<div *ngIf="!isFLNAPIerror && isSSOerror && invalidToken && ssoSource">
				<p>{{ssoSource}} Error:</p>
				<ul>
					<li>Token failed validation</li>
					<!-- <li *ngFor="let error of errorArray">{{ error }}</li> -->
				</ul>
			</div>
            <p>Please <a href="mailto:clientcare@firstlegal.com">contact support</a> if the issue persists, or click the <a (click)="retry()">retry</a> button to try again.</p>
            <button mat-flat-button color="primary" (click)="retry()">Retry Login</button>
        </mat-card-content>
    </mat-card>
	<mat-card *ngIf="directLoginBlock">
		<mat-card-title>
			Direct Login Violation
		</mat-card-title>
		<mat-card-content *ngIf="directLoginBlock">
			<div>
				The client associated with this account has disabled direct login:
				<p>{{errorMessage}}</p>
			</div>
			<p>Please <a href="mailto:clientcare@firstlegal.com">contact support</a> if there are any issues, or click the <a (click)="retry()">retry</a>button to return to the login screen.</p>
            <button mat-flat-button color="primary" (click)="retry()">Retry Login</button>
		</mat-card-content>
	</mat-card>
</div>
